import config from "../config/config";

export function targetLink() {
  //console.log('onfig.irbisProMode', config.irbisProMode)
  return config.irbisProMode ? '_self' : '_blank'
}